import { Button, Divisor, Typography } from '@recruit-robin/robin-theme/web-components';
import {
  ArrowRight,
  Briefcase_01,
  Check,
  RobinIcon,
  RobinLogoText,
  XClose,
} from '@recruit-robin/robin-theme/web-icons';

import { useGetJobImproved } from '@/entities/job';
import { useDictionary } from '@/shared/lib/i18n';
import { sanitizeEmailHtml } from '@/utils/sanitizeEmailHtml';
import { PoweredByRobin } from 'shared/ui/powered-by-robin';
import { TenantLogo } from 'shared/ui/tenant-logo';
import { useStyles } from './MessagePreview.styles';
import type { MessagePreviewProps } from './MessagePreview.types';

export const MessagePreview = ({ message, jobImprovedId, onViewJob, jobTitle, isIndeedFlow }: MessagePreviewProps) => {
  const dictionary = useDictionary();
  const classes = useStyles();

  const { data: jobImproved } = useGetJobImproved(jobImprovedId);
  const resolvedJobTitle = jobTitle ?? jobImproved?.jobTitle;
  const primaryColorCss = TenantLogo.useColorsCss();

  return (
    <div css={classes.root}>
      <div css={classes.logo}>
        <TenantLogo
          fallback={
            <>
              <RobinIcon size={28} />
              <RobinLogoText height={24} />
            </>
          }
        />
      </div>

      <Divisor customCss={classes.divisor} color={(c) => c.neutral.variant[30]} />

      <div css={[classes.jobDetails, primaryColorCss]} onClick={onViewJob}>
        <div css={classes.jobDetailsTitle}>
          <Briefcase_01 size={18} />

          <Typography variant={(v) => v.body.short} inline>
            {resolvedJobTitle}
          </Typography>
        </div>

        <div css={classes.jobDetailsView}>
          <Typography variant={(v) => v.supporting.label} inline>
            {dictionary.viewFullJobDetails}
          </Typography>
          <ArrowRight size={18} />
        </div>
      </div>

      <div css={classes.message}>
        <Typography variant={(v) => v.body.short} color={(c) => c.neutral.variant[70]}>
          <span dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(message) }} />
        </Typography>
      </div>

      <div css={classes.buttons}>
        {isIndeedFlow ? (
          <Button
            label={dictionary.showQuestionnaire}
            onClick={console.log}
            style="filled"
            type="highlight-light"
            contained
            customCss={primaryColorCss}
          />
        ) : (
          <>
            <Button
              label={dictionary.interested}
              onClick={console.log}
              style="filled"
              type="highlight-light"
              startIcon={Check}
              contained
              customCss={primaryColorCss}
            />
            <Button
              label={dictionary.notInterested}
              onClick={console.log}
              style="text"
              type="subtle2"
              startIcon={XClose}
              contained
            />
          </>
        )}
      </div>

      <PoweredByRobin />
    </div>
  );
};
